export function GoogleAdsScript({ adTagId }) {
  // useEffect(() => {
  //   if (!adTagId) return;

  //   const loadGoogleAds = () => {
  //     // 1. Load the Google Ads gtag.js script
  //     const script = document.createElement('script');
  //     script.src = `https://www.googletagmanager.com/gtag/js?id=${adTagId}`;
  //     script.async = true;
  //     document.head.appendChild(script);

  //     // 2. Inject config/init script
  //     const inlineScript = document.createElement('script');
  //     inlineScript.innerHTML = `
  //       window.dataLayer = window.dataLayer || [];
  //       function gtag(){dataLayer.push(arguments);}
  //       gtag('js', new Date());
  //       gtag('config', '${adTagId}');
  //     `;
  //     document.head.appendChild(inlineScript);
  //   };

  //   if (document.readyState === 'loading') {
  //     document.addEventListener('DOMContentLoaded', loadGoogleAds);
  //   } else {
  //     loadGoogleAds();
  //   }

  //   return () => {
  //     document.removeEventListener('DOMContentLoaded', loadGoogleAds);
  //   };
  // }, [adTagId]);

  return (
    <>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${adTagId}`}
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${adTagId}');
              `,
        }}
      />
    </>
  );
}
